module.exports = __webpack_public_path__ + "static/img/BASEindex.c9ee35f4.png";